import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import i18n from '@/i18n'
import {
  UserDetailsView,
  userAvailabilitySemesterQueryOptions,
  userQueryOptions
} from '@/modules/users'
import { getMetaWithPageTitle } from '@/utils/get-page-title'
import { isSelectedSemesterInOptions } from '@/utils/is-selected-semester-in-options'

export const Route = createFileRoute('/_auth/users/$userId/details')({
  component: UserDetailsView,
  validateSearch: z.object({
    setAvailability: z.boolean().optional().catch(false),
    semesterId: z.string().catch('')
  }),
  loaderDeps: ({ search }) => ({ search }),
  loader: async ({ deps: { search }, context, params }) => {
    const [semesters, user] = await Promise.all([
      context.queryClient.ensureQueryData(
        userAvailabilitySemesterQueryOptions({ userId: params.userId })
      ),
      context.queryClient.ensureQueryData(userQueryOptions(params.userId))
    ])

    if (
      !search.semesterId ||
      !isSelectedSemesterInOptions(search.semesterId, semesters.options)
    ) {
      throw redirect({
        replace: true,
        to: '/users/$userId/details',
        params,
        search: {
          semesterId: semesters.currentSemester?.id
        }
      })
    }

    return user.name
  },
  head: ({ loaderData }) =>
    getMetaWithPageTitle([loaderData, i18n.t('title.details', { ns: 'users' })])
})
